import { useRouter } from "next/router"
import { trpc } from "~/trpc/client"
import { PrequalForm, PrequalFormValues } from "./PrequalForm"

export const PrequalWrapper = () => {
  const router = useRouter()
  const mutation = trpc.useMutation("prequal.submit")

  const submitPrequal = async ({
    liraProvince,
    planValue,
    amountToUnlock,
    requireAdvance,
    ...prequal
  }: PrequalFormValues) => {
    const { id } = await mutation.mutateAsync({
      ...prequal,
      liraProvince: liraProvince ?? "",
      planValue: planValue ?? 0,
      amountToUnlock: amountToUnlock ?? 0,
      requireAdvance: requireAdvance ?? false,
    })
    router.push(`/application/${id}`)
  }

  return <PrequalForm mutation={mutation} save={submitPrequal} />
}
